import Css from "./style.module.scss";

import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import Badge from "nlib/ui/Badge";
import Constants from "const/Constants";
import DocumentPaymentTypes from "const/DocumentPaymentTypes";
import DocumentTypes from "const/DocumentTypes";
import React from "react";

const THEMES = {
  [DocumentTypes.INVOICE]: "positive",
  [DocumentTypes.SALES_RECEIPT]: "primary",
  [DocumentTypes.BILL]: "negative",
  [DocumentTypes.RECEIPT]: "alternative"
};

const TypeCell = ({ documentData: { type, paymentType } }) => {
  const { uiTexts } = useSelector(getTextsData);

  const billType = paymentType === DocumentPaymentTypes.BUY && type === DocumentTypes.INVOICE;

  const typeContent = (paymentType && type && (billType ? DocumentTypes.BILL : type));

  const textContent = uiTexts[typeContent] || uiTexts.unknown;

  return (
    <div className={Css.typeCell}>
      <div
        className={Css.documentType}
        title={textContent || undefined}>
        <Badge
          className={Css.badge}
          title={textContent || Constants.EMPTY_PLACEHOLDER}
          theme={THEMES[typeContent]}>
          {textContent || Constants.EMPTY_PLACEHOLDER}
        </Badge>
      </div>
    </div>
  );
};

export default React.memo(TypeCell);
